export default "/fr/_next/static/assets/images/sprite.ac87303fd9a9b5be16ddc7a71534ea58.svg";